import {
  Injectable,
  Output,
  EventEmitter,
  ElementRef,
  OnDestroy
} from '@angular/core';
import * as elementResizeDetectorMaker from 'element-resize-detector';
import * as _ from 'lodash';

import { StickyComponent } from './sticky.component';
import { debounce } from 'lodash';


@Injectable()
export class StickyService implements OnDestroy {

  stickEvent: EventEmitter<StickyComponent> = new EventEmitter();
  _debounceEmit: Function;
  _debounceDefinePosition: Function;
  stickyList: StickyComponent[] = [];
  offsetTop: number = 0;
  container: ElementRef;
  private _className: string = 'sticky';
  private _lastScrollTop: number = 0;
  private _resizeDetector: any;

  init(offsetTop = 0, stickClass = 'sticky', container?: ElementRef | void) {
    this.offsetTop = offsetTop;
    this._className = stickClass;
    this._debounceEmit = debounce((item: any) => {
      this.stickEvent.emit(item);
    }, 300);
    if (container) {
      this._initResizeDetector(container);
    }
  }

  ngOnDestroy() {
    this.reset();
  }

  handleScrolling() {
    if (this._isScrollingDown) {
      this._handleScrollingDown();
    } else {
      this._handleScrollingUp();
    }
    this._lastScrollTop = this._pageYOffset;
  }

  public addItem(item: StickyComponent) {
    this.stickyList.push(item);
    if (item.order) {
      this.stickyList = _.sortBy(this.stickyList, (sticky: StickyComponent) => {
        return Number(sticky.order);
      });
    }
  }

  public definePositions(): void {
    this.stickyList.forEach((sticky: StickyComponent) => {
      sticky.definePosition();
    });
  }

  public getTopPosition(nextItem: StickyComponent, item: StickyComponent): number {
    return nextItem.position - item.clientHeight;
  }

  public reset(): void {
    if (this._resizeDetector) {
      this._resizeDetector.uninstall(this.container.nativeElement);
      this._resizeDetector = null;
    }
    this.stickyList = [];
    this._debounceEmit = null;
  }

  private _handleScrollingDown() {
    this.stickyList.forEach((item: StickyComponent, index: number, array: Array<StickyComponent>) => {
      if (item.scrolled || this._scrollWithOffset <= item.position) { return; }
      if (!item.active) { this._setActive(item); }
      const nextItem = array[index + 1];
      if (nextItem && (this._pageYOffset >= this._getNextItemPos(nextItem, item))) {
        this._setScrolled(item, this.getTopPosition(nextItem, item));
      }
    });
  }

  private _handleScrollingUp(): void {
    this.stickyList.forEach((item: StickyComponent) => {
      if (item.active && this._scrollWithOffset <= item.position) {
        item.removeClass(this._className);
        item.active = false;
      }
      if (item.scrolled && this._scrollWithOffset <= item.offsetTop) {
        this._setActive(item);
        item.removeAttr('style');
      }
    });
  }

  private _emit(item: StickyComponent) {
    this.stickEvent.emit(item);
  }

  private _initResizeDetector(container: ElementRef) {
    if (!container) { return; }
    this._debounceDefinePosition = debounce(this.definePositions, 100);
    this.container = container;
    this._resizeDetector = elementResizeDetectorMaker();
    this._resizeDetector.listenTo(this.container.nativeElement, () => {
      this._debounceDefinePosition();
    });
  }

  private get _scrollWithOffset(): number {
    return this._pageYOffset + this.offsetTop;
  }

  private get _pageYOffset(): number {
    return window.pageYOffset;
  }

  private get _isScrollingDown(): boolean {
    return this._pageYOffset > this._lastScrollTop;
  }

  private _getNextItemPos(nextItem: StickyComponent, currentItem: StickyComponent): number {
    return nextItem.offsetTop - this.offsetTop - currentItem.clientHeight;
  }

  private _setActive(item: StickyComponent) {
    item.active = true;
    item.scrolled = false;
    item.addClass(this._className);
    this._debounceEmit(item);
  }

  private _setScrolled(item: StickyComponent, topPosition: number) {
    item.removeClass(this._className)
    .setTopPosition(topPosition);
    item.scrolled = true;
    item.active = false;
  }
}
